import { ErrorQueryBoundary, ErrorFallback } from "../../../components/index";
import { ShopCategories } from "../../../components/web-app/index";

const Shop = () => {
  return (
    <ErrorQueryBoundary errorFallback={<ErrorFallback />}>
      <ShopCategories />
    </ErrorQueryBoundary>
  );
};

export default Shop;